import { IconSvg, IconSvgProps } from "./icon"

export default function Plane(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M3.786 5.929h2.3a.7.7 0 0 1 .685.542L7.5 9.33 14.643 7.9a5.271 5.271 0 0 1 6.286 5.129 1.429 1.429 0 0 1-1.429 1.428h-6.286l-1.428 2.257a2.855 2.855 0 0 1-2.4 1.315H7.814a.716.716 0 0 1-.628-1.043L8.443 14.5H4.5a1.429 1.429 0 0 1-1.429-1.429V6.643a.714.714 0 0 1 .715-.714Z" />
    </IconSvg>
  )
}
